import { ValueFormatterParams, ICellRendererParams } from "ag-grid-community";
// Local
import { convertFSTimestampToLuxonDT } from "../../utils/convertFSTimestampToLuxonDT";
import { getReadableStiltInvoiceStatus } from "../../models/invoice";
import { getReadablePOStatus } from "../../models/purchase-order";

export function getRenderBoolean(params: ICellRendererParams): string {
  if (params.value === true) return "Yes";
  if (params.value === false) return "No";
  return "";
}

// TODO: find the places this should be used
/** use for valueFormatter */
export function getTimestampFormatted(params: ValueFormatterParams): string {
  const ts = params.value;
  if (!ts) return "";
  try {
    const lux = convertFSTimestampToLuxonDT(ts);
    return lux.toLocal().toFormat("LL/dd/yy hh:mm a");
  } catch (_e) {
    return "";
  }
}

/** use for valueFormatter */
export function getBooleanFormatted(params: ValueFormatterParams): string {
  if (params.value === true) return "Yes";
  if (params.value === false) return "No";
  return "";
}

export function renderInvoiceStatus(params: ICellRendererParams): JSX.Element {
  let customBg = "bg-primary text-primaryButtonText";
  switch (params.value) {
    case "paid":
      customBg = "bg-greenPass text-white";
      break;
    case "partiallyPaid":
      customBg = "bg-orangeError text-white";
      break;
    case "canceled":
    case "draft":
      customBg = "bg-gray-200 text-black";
      break;
  }

  return (
    <div className="flex items-center">
      <div
        className={`m-1 rounded-full px-2.5 pb-1 pt-0.5 text-xs font-medium ${customBg} capitalize`}
      >
        {getReadableStiltInvoiceStatus(params.value)}
      </div>
    </div>
  );
}

export function renderPOStatus(params: ICellRendererParams): JSX.Element {
  let customBg = "bg-gray-200 text-black";

  switch (params.value) {
    case "draft":
      customBg = "bg-gray-200 text-gray-800";
      break;
    case "pending":
      customBg = "bg-yellow-100 text-yellow-800";
      break;
    case "approved":
      customBg = "bg-blue-100 text-blue-800";
      break;
    case "sent":
      customBg = "bg-indigo-100 text-indigo-800";
      break;
    case "partiallyReceived":
      customBg = "bg-orange-100 text-orange-800";
      break;
    case "completed":
      customBg = "bg-green-100 text-green-800";
      break;
    case "canceled":
      customBg = "bg-red-100 text-red-800";
      break;
  }

  return (
    <div className="flex items-center">
      <div
        className={`m-1 rounded-full px-2.5 pb-1 pt-0.5 text-xs font-medium ${customBg} capitalize`}
      >
        {getReadablePOStatus(params.value)}
      </div>
    </div>
  );
}
